import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import rsjiActions from "./data/rsji-actions.js";

const initVue = data => {
  const props = {
    ...data
  }

  createApp(App,props)
    .use(router)
    .mount("#rsji-actions-app")
}

rsjiActions.getActions().then(initVue)


// Accordion Hash Hotfix
const preventAccordionHashes = () => {
    // Get All Toggles
    let accordionToggles = document.querySelectorAll('.accordion-toggle');

    accordionToggles.forEach(toggle => {
        // Replace them with clones to remove all Event Listeners
        let newToggle = toggle.cloneNode(true);
        toggle.parentNode.replaceChild(newToggle, toggle);

        // Remove normal Accordion Collapsed State
        let accordion = newToggle.nextElementSibling;
        accordion.classList.remove('collapsed');
        accordion.style.maxHeight = '0px';

        // Bind new toggling
        newToggle.addEventListener('click', () =>{

            // Toggle Icons
            let icon = newToggle.querySelector('svg');
            icon?.classList.toggle('fa-plus');
            icon?.classList.toggle('fa-minus');

            // Toggle Accordion
            let contentHeight = accordion?.querySelector('.content')?.clientHeight + 'px';
            accordion.style.maxHeight = (accordion.style.maxHeight == '0px') ? contentHeight : '0px';
        })
    })
}
document.addEventListener('DOMContentLoaded', function () {
  preventAccordionHashes();
}, false);